export const roundRatingsNumber = (num: number) => {
  if (num > 10000) {
    return '10000+';
  }
  if (num > 1000) {
    return '1000+';
  }
  if (num > 100) {
    return '100+';
  }
  if (num > 10) {
    return '10+';
  }
  return num.toString();
};
